namespace SPA
{

	export namespace Survey
	{
		enum FormState
		{
			NULL,
			NEW,
			OLD
		}

		export class SurveyObjectCreator
			extends ui.tab.TabHTMLPresentation
		{

			private	m_Company:							Wollmilch.CompanyObject;
			private m_Form: 								ui.Form.Form;
			private m_ObjectData: 					ui.Box.Box;
			private	m_SurveyInputs:					ui.Form.BasicInputField[];
			private	m_CustomerData:					ui.Box.Box;
			private	m_CustomerType:					ui.Form.RadioGroup;
			private	m_CustomerInputs:				ui.Form.BasicInputField[];
			// @ts-ignore
			private	m_CustomerList:					any[];
			private realtorData:						string[];

			private	m_ContactPersonData:		ui.Box.Box;
			private	m_ContactPersonInputs:	ui.Form.BasicInputField[];
			private	m_TenantData:					ui.Box.Box;
			private	m_TenantInputs:				ui.Form.BasicInputField[];

			private m_ReferenceObject:			Wollmilch.Object.ICustomerObjectObject|null;

			private UnitCount_AsResultByProduct: number;

			public constructor( company: Wollmilch.CompanyObject, reference?: Wollmilch.Object.ICustomerObjectObject )
			{
				super();

				this.Initialize(
				{
					aria:
					{
						label: app.getMessage( 'Survey.NEW.form' )
					}
				}
				);

				this.m_ReferenceObject = reference || null ;

				this.m_ContactPersonInputs					= [];
				this.m_ContactPersonData 						= new ui.Box.Box();
				this.m_TenantInputs 								= [];
				this.m_TenantData 									= new ui.Box.Box();

				this.m_CustomerInputs								= [];
				this.m_CustomerData									= new ui.Box.Box();
				this.m_Company											= company;
				this.m_SurveyInputs 								= [];
				this.m_ObjectData										= new ui.Box.Box();
				this.UnitCount_AsResultByProduct 		= 1;
				this.realtorData										= [];
				this.m_Form													= new ui.Form.Form(
				{
					action: 'object/new',
					classes: [ 'form-horizontal' ],
					invalid: ( inputs: Array<ui.Form.BasicInputField<HTMLElement>> ) =>
					{
						app.addNotify(
						{
							body: [ ui.$$.p().text( app.getMessage( 'Survey.ERROR.INPUT.form_body' ) ) ],
							context: 'danger',
							timeout: Number(app.getConfigValue("ToastTimeout")),
							title: [ ui.$$.h( 4, app.getMessage( 'Survey.ERROR.INPUT.form_title' ) ) ],
						});
					},
					method: 'POST',
					notSwitchable: true,
					submit: ( method: ui.Form.FormMethod, action: string, parameter: ui.Form.IFormParameter ) =>
					{
						new Wollmilch.AJAX(
						{
							data: parameter,
							method,
							on:
							{
								beforeSend: ( options: Wollmilch.IAJAXOptions ) =>
								{
									if ( this.m_ReferenceObject && typeof this.m_ReferenceObject === 'object' )
									{
										delete( options.data as any ).address;
										( options.data as any ).reference = this.m_ReferenceObject.ObjectNumber;
									}

									if ( (options.data as any).leted )
									{
										if ( (options.data as any).tenant.unknown )
										{
											// delete( options.data as any ).tenant;
										}
									}
									else
									{
										delete( options.data as any ).tenant;
									}
								},
								success: ( text: string ): void =>
								{
									let obj;
									try
									{
										obj = Wollmilch.jsonize( text );
									}
									catch ( e )
									{
										app.addNotify(
										{
											body: [ ui.text( app.getMessage( 'Survey.ERROR.INPUT.no_success' ) ) ],
											context: 'warning',
											timeout: 2500,
											title: [ ui.h( 3, app.getMessage( 'Survey.ERROR.title' ) ) ],
										});
										return;
									}
									if ( obj && !obj.success && obj.error )
									{
										app.addNotify(
										{
											body: [ ui.text( app.getMessage( 'Survey.ERROR.INPUT.no_success' ) ) ],
											context: 'warning',
											timeout: 2500,
											title: [ ui.h( 3, app.getMessage( 'Survey.ERROR.title' ) ) ],
										});
										return;
									}
									app.addNotify(
									{
										body: [ ui.text( app.getMessage( 'Survey.NEW.success' ) ) ],
										context: 'success',
										timeout: 2500,
										title: [ ui.h( 3, app.getMessage( 'Survey.GENERAL.success_title' ) ) ],
									});
								}
							},
							url: action,
						},
						Wollmilch.AJAXCallbase_e.TEMPSURVEY
						).send();
					}
				}
				)
				.append(
					ui.$$.div().addClass( 'row' )
						.append( ui.$$.div().addClass( 'col-sm-12 col-md-6' )
							.append( this.m_ObjectData.Root()  )
							.append( this.m_TenantData.Root().addClass('noDisplay') )
						)
						.append( ui.$$.div().addClass( 'col-sm-12 col-md-6' )
							.append( this.m_CustomerData.Root() )
							.append( this.m_ContactPersonData.Root() )
						)
				) as ui.Form.Form;

				this.m_CustomerType	=	new ui.Form.RadioGroup(
					{
						css:
						{
							'text-align': 'center'
						},
						inline: 2,
						name: 'customer.type',
						radioButtons:
						[
							{
								descriptor:
								{
									on:
									{
										click: () =>
										{
											this.build();
										}
									}
								},
								title: app.getMessage( 'Survey.NEW.CUSTOMER-TYPE.NEW' ),
								value: 'NEW',
							},
							{
								descriptor:
								{
									on:
									{
										click: () =>
										{
											this.build();
										}
									}
								},
								title: app.getMessage( 'Survey.NEW.CUSTOMER-TYPE.OLD' ),
								value: 'OLD',
							}
						],
						required: true,
					}
				);

				this.m_ObjectData.addTitle( app.getMessage( 'Survey.LABEL.TITLE.estate' ) );
				this.m_CustomerData.addTitle( app.getMessage( 'Survey.LABEL.TITLE.customer' ) );
				this.m_ContactPersonData.addTitle( app.getMessage( 'Survey.LABEL.TITLE.contact' ) );
				this.m_TenantData.addTitle( app.getMessage( 'Survey.LABEL.TITLE.tenant' ) );

				this.append( this.m_Form );

				this.m_Form.Initialize();

				new ui.Box.Box().append(
					ui.$$.div().append(
						ui.$$.div().append(
							ui.$$.div()
								.append( $( this.m_Form.Buttons.submit.getElement() ).text( app.getMessage( 'Aux.SAVE_BTN' ) ) )
								.append( $( this.m_Form.Buttons.cancel.getElement() ).text( app.getMessage( 'Aux.ABORT_BTN' ) ) )
									.on( 'click', () => app.getGlobalTabControl().removeTab( this.m_Entry ) )
							.addClass( 'col-xs-12' )
						).addClass( 'row' )
					).addClass( 'container-fluid' )
				).appendTo( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );

				this.rebuild(this.Root());
			}

			public rebuild( root: JQuery|ui.base.BaseHTMLElement ): SurveyObjectCreator
			{
				super.rebuild( root );

				this.build();

				return this;
			}

			private buildSurveyForm()
			{
				if ( this.m_SurveyInputs.length == 0 )
				{
					this.m_SurveyInputs = SPA.gui.form.PostalAddressList( 'address' );

					let valueTenancy: string																	= '';
					let valueBuildingType: Wollmilch.TempSurvey.BuildingType	= '';
					let valueInfo: string																			= '';
					let valueGrannyFlat: boolean															= false;

					if ( this.m_ReferenceObject !== null )
					{
						switch ( this.m_ReferenceObject.Type )
						{
							case 'LetRealtorObject':
							case 'DisposalRealtorObject':
								const obj	= this.m_ReferenceObject as Wollmilch.Realtor.Object;

								if ( !obj.Premise )
								{
									break;
								}

								if ( !obj.Premise.Building || obj.Premise.Building.length === 0 )
								{
									break;
								}

								// FIXME welches Building soll angezeigt werden (derzeit fest das erste Building)
								valueTenancy = app.getMessage( 'Survey.NEW.TENANCY_RATE.' + obj.Premise.Building[0].Data.General.TenancyRate);
								valueBuildingType = obj.Premise.Building[0].Data.General.BuildingKind || '';
								valueInfo = obj.Premise.Building[0].Data.General.Info || '';
								valueGrannyFlat = obj.Premise.Building[0].Data.General.GrannyFlat;
								break;
						}
					}

					this.m_SurveyInputs.push(
						new ui.Form.RadioGroup(
							{
								inline: 2,
								name: 'product',
								radioButtons:
								[
									{
										descriptor:
										{
											on:
											{
												click: () =>
												{
													this.m_SurveyInputs[13].value(1);
													this.m_ContactPersonData.remClass('noDisplay');

													this.m_SurveyInputs[15].State( ui.Form.InputState.REQUIRED );
													this.m_SurveyInputs[16].State( ui.Form.InputState.REQUIRED );
													this.m_SurveyInputs[17].State( ui.Form.InputState.REQUIRED );
													this.m_SurveyInputs[18].State( ui.Form.InputState.REQUIRED );
													this.m_SurveyInputs[19].State( ui.Form.InputState.REQUIRED );
													this.m_SurveyInputs[20].State( ui.Form.InputState.REQUIRED );
												}
											},
										},
										title: app.getMessage( 'Product.TempSurvey.InsideOutside' ),
										value: '1',
									},
									{
										descriptor:
										{
											on:
											{
												click: () =>
												{
													this.m_SurveyInputs[13].value(0);
													this.m_ContactPersonData.addClass('noDisplay');

													this.m_SurveyInputs[15].State( ui.Form.InputState.ENABLED );
													this.m_SurveyInputs[16].State( ui.Form.InputState.ENABLED );
													this.m_SurveyInputs[17].State( ui.Form.InputState.ENABLED );
													this.m_SurveyInputs[18].State( ui.Form.InputState.ENABLED );
													this.m_SurveyInputs[19].State( ui.Form.InputState.ENABLED );
													this.m_SurveyInputs[20].State( ui.Form.InputState.ENABLED );
												},
											},
										},
										title: app.getMessage( 'Product.TempSurvey.Outside' ),
										value: '2',
									},
								],
								required: true,
								value: '',
							},
						),
					);

					this.m_SurveyInputs.push(
						new ui.Form.DateInput(
							new Date(),
							'd.m.Y',
							{
								name: 'Forecast',
								required: true,
							},
						),
					);

					this.m_SurveyInputs.push(
						new ui.Form.RadioGroup(
							{
								inline: 3,
								name: 'Tenancy',
								radioButtons:
								[
									{
										descriptor: {},
										title: app.getMessage( 'Survey.NEW.TENANCY_RATE.empty' ),
										value: 'leer',
									},
									{
										descriptor: {},
										title: app.getMessage( 'Survey.NEW.TENANCY_RATE.halffull' ),
										value: 'teilweise leer',
									},
									{
										descriptor: {},
										title: app.getMessage( 'Survey.NEW.TENANCY_RATE.full' ),
										value: 'bezogen',
									},
								],
								required: true,
								value: valueTenancy,
							},
						),
					);

					this.m_SurveyInputs.push(
						new ui.Form.Checkbox(
						{
							descriptor:
							{
								name: 'DevArea'
							},
							title: app.getMessage( 'Survey.LABEL.OBJECT.devarea' ),
						},
						),
					);

					this.m_SurveyInputs.push(
						new ui.Form.Checkbox(
							{
							descriptor:
							{
								name: 'GrannyFlat',
							},
							title: app.getMessage( 'Survey.LABEL.OBJECT.grannyflat' ),
						},
						).value( valueGrannyFlat ),
					);

					this.m_SurveyInputs.push(
						new ui.Form.RadioGroup(
							{
								inline: 5,
								name: 'BuildingType',
								radioButtons:
								[
									{
										descriptor: {},
										title: app.getMessage( 'Survey.NEW.BUILDING_KIND.FamilyHouse' ),
										value: 'FamilyHouse',
									},
									{
										descriptor: {},
										title: app.getMessage( 'Survey.NEW.BUILDING_KIND.SemiHouse' ),
										value: 'SemiHouse',
									},
									{
										descriptor: {},
										title: app.getMessage( 'Survey.NEW.BUILDING_KIND.EndHouse' ),
										value: 'EndHouse',
									},
									{
										descriptor: {},
										title: app.getMessage( 'Survey.NEW.BUILDING_KIND.MiddleHouse' ),
										value: 'MiddleHouse',
									},
									{
										descriptor: {},
										title: app.getMessage( 'Survey.NEW.BUILDING_KIND.ApartmentHouse' ),
										value: 'ApartmentHouse',
									},
									{
										descriptor: {},
										title: app.getMessage( 'Survey.NEW.BUILDING_KIND.LivingAndBusinessHouse' ),
										value: 'LivingAndBusinessHouse',
									},
									{
										descriptor: {},
										title: app.getMessage( 'Survey.NEW.BUILDING_KIND.Apartment' ),
										value: 'Apartment',
									},
									{
										descriptor: {disabled: true},
										title: app.getMessage( 'Survey.NEW.BUILDING_KIND.OfficeBuilding' ),
										value: 'OfficeBuilding',
									},
									{
										descriptor: {disabled: true},
										title: app.getMessage( 'Survey.NEW.BUILDING_KIND.RepairShop' ),
										value: 'RepairShop',
									},
									{
										descriptor: {disabled: true},
										title: app.getMessage( 'Survey.NEW.BUILDING_KIND.StoreHouse' ),
										value: 'StoreHouse',
									}
								],
								required: true,
								value: valueBuildingType,
							},
						),
					);

					this.m_SurveyInputs.push(
						new ui.Form.TextArea(
							{
								css:
								{
									resize: 'vertical'
								},
								name: 'Info',
								required: false,
								rows: 5,
								text: valueInfo,
							},
						),
					);

					this.m_SurveyInputs.push(
						new ui.Form.NumberInput(
							this.UnitCount_AsResultByProduct,
							{
								min: 0,
								name: 'UnitCount',
								required: true,
							},
						),
					);

					this.m_SurveyInputs.push(
						new ui.Form.Checkbox(
						{
							descriptor:
							{
								name: 'leted',
								on:
								{
									click: () =>
									{
										if ( this.m_TenantData.hasClass( 'noDisplay' ) )
										{
											this.m_TenantData.remClass( 'noDisplay' );
											this.m_SurveyInputs[22].State( ui.Form.InputState.REQUIRED );
											this.m_SurveyInputs[23].State( ui.Form.InputState.REQUIRED );
											this.m_SurveyInputs[24].State( ui.Form.InputState.REQUIRED );
											this.m_SurveyInputs[25].State( ui.Form.InputState.REQUIRED );
										}
										else
										{
											this.m_TenantData.addClass( 'noDisplay' );
											this.m_SurveyInputs[22].State( ui.Form.InputState.ENABLED );
											this.m_SurveyInputs[23].State( ui.Form.InputState.ENABLED );
											this.m_SurveyInputs[24].State( ui.Form.InputState.ENABLED );
											this.m_SurveyInputs[25].State( ui.Form.InputState.ENABLED );
										}
									},
								},
							},
							title: app.getMessage( 'Survey.LABEL.OBJECT.leted' ),
						},
						),
					);

					// Ansprechpartner
					this.m_SurveyInputs.push(
						new ui.Form.TextInput(
							'',
							{
								name: 'contactperson.surname',
								placeholder: app.getMessage( 'Survey.LABEL.PERSON.surname' ),
								required: false,
							},
						),
					);

					this.m_SurveyInputs.push(
						new ui.Form.TextInput(
							'',
							{
								name: 'contactperson.name',
								placeholder: app.getMessage( 'Survey.LABEL.PERSON.name' ),
								required: false,
							},
						),
					);

					this.m_SurveyInputs.push(
						new ui.Form.TelInput(
							'',
							{
								name: 'contactperson.phone.number',
								placeholder: app.getMessage( 'Survey.PAGE.PHONE.number' ),
								required: false,
							},
						),
					);

					this.m_SurveyInputs.push(
						new ui.Form.Select(
							{
								blank: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.selection' ),
								name: 'contactperson.phone.type',
								option:
								{
									home: app.getMessage( 'Survey.LABEL.PERSON.PHONE.home' ),
									mobile: app.getMessage( 'Survey.LABEL.PERSON.PHONE.mobile' ),
									office: app.getMessage( 'Survey.LABEL.PERSON.PHONE.office' )
								},
								required: false,
							},
						),
					);

					this.m_SurveyInputs.push(
						new ui.Form.Select(
							{
								blank: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.reachability' ),
								name: 'contactperson.phone.reachability',
								option:
								{
									evening: app.getMessage( 'Survey.LABEL.PERSON.PHONE.evening' ),
									fullday: app.getMessage( 'Survey.LABEL.PERSON.PHONE.fullday' ),
									morning: app.getMessage( 'Survey.LABEL.PERSON.PHONE.morning' ),
								},
								required: false,
							},
						),
					);

					this.m_SurveyInputs.push(
						new ui.Form.EmailInput(
							'',
							{
								name: 'contactperson.email',
								placeholder: app.getMessage( 'Survey.LABEL.PERSON.email' ),
								required: false,
							},
						),
					);

					// Mieter (21)
					this.m_SurveyInputs.push(
						new ui.Form.Checkbox(
						{
							descriptor:
							{
								name: 'tenant.unknown',
								on:
								{
									click: () =>
									{
										// TODO Felder/Pflichteingabe setzen/rausnehmen
										this.m_SurveyInputs[21].val() ? this.m_SurveyInputs[22].State( ui.Form.InputState.ENABLED ) : this.m_SurveyInputs[22].State( ui.Form.InputState.REQUIRED );
										this.m_SurveyInputs[21].val() ? this.m_SurveyInputs[23].State( ui.Form.InputState.ENABLED ) : this.m_SurveyInputs[23].State( ui.Form.InputState.REQUIRED );
										this.m_SurveyInputs[21].val() ? this.m_SurveyInputs[24].State( ui.Form.InputState.ENABLED ) : this.m_SurveyInputs[24].State( ui.Form.InputState.REQUIRED );
										this.m_SurveyInputs[21].val() ? this.m_SurveyInputs[25].State( ui.Form.InputState.ENABLED ) : this.m_SurveyInputs[25].State( ui.Form.InputState.REQUIRED );
									},
								},
							},
							title: app.getMessage('Survey.LABEL.OBJECT.tenantunknown')
						},
						),
					);

					this.m_SurveyInputs.push(
						new ui.Form.TextInput(
							'',
							{
								name: 'tenant.surname',
								placeholder: app.getMessage( 'Survey.LABEL.PERSON.surname' ),
								required: false,
							},
						),
					);

					this.m_SurveyInputs.push(
						new ui.Form.TextInput(
							'',
							{
								name: 'tenant.name',
								placeholder: app.getMessage( 'Survey.LABEL.PERSON.name' ),
								required: false,
							},
						),
					);

					this.m_SurveyInputs.push(
						new ui.Form.TelInput(
							'',
							{
								name: 'tenant.phone',
								required: false,
								placeholder: app.getMessage( 'Survey.LABEL.PERSON.PHONE.title' ),
							},
						),
					);

					this.m_SurveyInputs.push(
						new ui.Form.EmailInput(
							'',
							{
								name: 'tenant.email',
								required: false,
								placeholder: app.getMessage( 'Survey.LABEL.PERSON.email' ),
							},
						),
					);

				}

				let addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) =>
				{
					this.m_Form.Input( input ); input.Base().addClass( baseclass.join( ' ' ) );
				};

				this.m_ObjectData.append(
					ui.$$.h( 4, app.getMessage( 'Survey.LABEL.OBJECT.object_address' ) ).css( 'color', '#888' )
				);

				SPA.gui.form.SimpleStyledPostalAddressList( this.m_Form, this.m_ObjectData, this.m_SurveyInputs );

				this.m_ObjectData.append( ui.$$.hr() ).append(
					ui.$$.h( 4, app.getMessage( 'Survey.NEW.survey_data' ) ).css( 'color', '#888' )
				);

				// Produkte
				addObjDataInput(
					this.m_SurveyInputs[6]
					.rebuild(
						ui.$$.div().addClass( 'form-group clearfix' )
						.append( ui.$$.label().text(
							app.getMessage( 'Survey.LABEL.PERSON.product' )
						).addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.m_ObjectData.Root() ),
					),
					[ 'col-xs-12', 'col-md-10' ],
				);

				let inputElement: any;
				// Forcast
				let fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
					.append( ui.$$.label().text(
						app.getMessage( 'Survey.LABEL.OBJECT.forecast' )
					).addClass( 'control-label col-xs-12 col-md-2' ) )
					.appendTo( this.m_ObjectData.Root() );
				addObjDataInput(this.m_SurveyInputs[7]
					.rebuild( fg ),
					[ 'col-xs-12', 'col-md-10' ],
				);

				// Bezugsstand
				addObjDataInput( this.m_SurveyInputs[8]
					.rebuild(
						ui.$$.div().addClass( 'form-group clearfix' )
						.append( ui.$$.label().text(
							app.getMessage( 'Survey.NEW.TENANCY_RATE.tenancy' )
						).addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.m_ObjectData.Root() )
					),
					[ 'col-xs-12', 'col-md-10' ],
				);

				// DevArea
				addObjDataInput(this.m_SurveyInputs[9]
					.rebuild(
						ui.$$.div().appendTo( this.m_ObjectData.Root() )
					),
					[ 'col-xs-12', 'col-md-3', 'col-md-offset-3' ]
				);

				// GrannyFlat
				addObjDataInput(this.m_SurveyInputs[10]
					.rebuild(
						ui.$$.div().addClass( 'form-group clearfix' ).appendTo( this.m_ObjectData.Root() ),
					),
					[ 'col-xs-12', 'col-md-3', 'col-md-offset-1' ],
				);

				// Gebäudeart
				addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) =>
				{
					this.m_Form.Input( input );
					input.Base().addClass( baseclass.join( ' ' ) );
				};

				addObjDataInput(this.m_SurveyInputs[11]
					.rebuild(
						ui.$$.div().addClass( 'form-group clearfix' ).appendTo( this.m_Form.Root() )
							.append( ui.$$.label().text(
								app.getMessage( 'Survey.PAGE.BUILDING_TYPE.label' )
							).addClass( 'control-label col-xs-12 col-md-2' ) )
							.appendTo( this.m_ObjectData.Root() ),
					),
					[ 'col-xs-12', 'col-md-10' ],
				);

				// Info
				fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
					.append( ui.$$.label().text(
						app.getMessage( 'Survey.LABEL.OBJECT.info' )
					).addClass( 'control-label col-xs-12 col-md-2' ) )
					.appendTo( this.m_ObjectData.Root() );
				addObjDataInput(this.m_SurveyInputs[12]
					.rebuild( fg ),
					[ 'col-xs-12', 'col-md-10' ],
				);

				// UnitCount
				fg = ui.$$.div()
					.append( ui.$$.label().text(
						app.getMessage( 'Survey.LABEL.OBJECT.unitcount' )
					).addClass( 'control-label col-xs-12 col-md-2' ) )
					.appendTo( this.m_ObjectData.Root() );

				addObjDataInput(this.m_SurveyInputs[13]
					.rebuild( fg ),
					[ 'col-xs-12', 'col-md-2' ],
				);

				// vermietet
				addObjDataInput(this.m_SurveyInputs[14]
					.rebuild(
						ui.$$.div().addClass( 'form-group clearfix' ).appendTo( this.m_ObjectData.Root() ),
					),
					[ 'col-xs-12', 'col-md-3', 'col-md-offset-3' ],
				);

			}

			private build()
			{
				this.m_ObjectData.empty();
				this.m_ObjectData.rebuild();
				this.m_CustomerData.empty();
				this.m_CustomerData.rebuild();
				this.m_ContactPersonData.empty();
				this.m_ContactPersonData.rebuild();
				this.m_TenantData.empty();
				this.m_TenantData.rebuild();

				ui.$$.div().addClass( 'form-group formless' ).appendTo( this.m_ObjectData.Root() )
				.append( ui.$$.p().addClass( 'form-required text-danger small-caps' ).text( app.getMessage( 'Aux.REQUIRED_INPUTS' ) ) );

				const fg = ui.$$.div().addClass( 'form-group formless' ).appendTo( this.m_CustomerData.Root() )
				.append( ui.$$.p().addClass( 'form-required text-danger small-caps' ).text( app.getMessage( 'Aux.REQUIRED_INPUTS' ) ) );

				this.m_CustomerType.rebuild( fg );

				if ( typeof this.m_ReferenceObject != 'object' )
				{
					fg.append( ui.$$.p().text( app.getMessage( 'Realtor.NEW.TITLE.CUSTOMER-TYPE.HELP-BLOCK' )
						+ app.getMessage( 'Aux.wildcard' ) ).addClass( 'help-block' ) );
				}

				this.m_CustomerInputs.forEach( (input) => this.m_Form.removeInput( input ) );

				const radio = this.m_CustomerType.val() as string;

				if ( radio == 'NEW' ) {				this.buildNewCustomerForm(); }
				else if ( radio == 'OLD' ) {	this.buildOldCustomerForm(); }

				this.buildSurveyForm();
				this.buildContactPersonForm();
				this.buildTenantForm();

				if ( typeof this.m_ReferenceObject === 'object' )
				{
					this.setValuesByRealtorObject();
				}

			}

			private setValuesByRealtorObject()
			{
				// Adresse
				const obj	= this.m_ReferenceObject as Wollmilch.Realtor.Object;

				this.m_SurveyInputs[0].value( obj.Address.Street ).Static(true);
				this.m_SurveyInputs[1].value( obj.Address.HouseNumber ).Static(true);
				this.m_SurveyInputs[2].value( obj.Address.PostalCode ).Static(true);
				this.m_SurveyInputs[3].value( obj.Address.City ).Static(true);
				this.m_SurveyInputs[4].value( obj.Address.State ).Static(true);
				this.m_SurveyInputs[5].value( obj.Address.Country ).Static(true);

				// Kunde
				this.buildOldCustomerForm();

				this.m_Form.Input( new ui.Form.HiddenNumberInput( obj.Customer.Customer.ID ? obj.Customer.Customer.ID : -1, 'customer.id' ) );
				this.m_Form.Input( new ui.Form.HiddenNumberInput( obj.Address.ID, 'address.id' ) );

				const clientObj = obj.Customer.Customer as Wollmilch.ClientObject;
				this.m_CustomerInputs[0].value( clientObj.Gender == 'f' ? 'Frau' : 'Herr' );
				this.m_CustomerInputs[2].value( clientObj.Title );
				this.m_CustomerInputs[3].value( clientObj.Name );
				this.m_CustomerInputs[4].value( clientObj.Surname );
				this.realtorData.push( (clientObj.Gender.toString() == '1') ? 'f' : 'm' );
				this.realtorData.push( clientObj.Title );
				this.realtorData.push( clientObj.Name );
				this.realtorData.push( clientObj.Surname );

				this.m_CustomerInputs[5].value( new Date( clientObj.Birthday ? clientObj.Birthday : '' ).pattern('d.m.Y') );
				this.realtorData.push( new Date( clientObj.Birthday ? clientObj.Birthday : '' ).pattern('d.m.Y') );

				obj.Customer.Customer.Address.forEach( (element: any) =>
				{
					if ( element.AddressType == 'PostalAddress' )
					{
						this.m_CustomerInputs[6].value( element.Street );
						this.m_CustomerInputs[7].value( element.HouseNumber );
						this.m_CustomerInputs[8].value( element.PostalCode );
						this.m_CustomerInputs[9].value( element.City );
						this.m_CustomerInputs[10].value( element.State );
						this.m_CustomerInputs[11].value( element.Country );

						this.realtorData.push( element.Street );
						this.realtorData.push( element.HouseNumber );
						this.realtorData.push( element.PostalCode );
						this.realtorData.push( element.City );
						this.realtorData.push( element.State );
						this.realtorData.push( element.Country );
					}
				});

				this.m_CustomerType.remove();
			}

			private buildNewCustomerForm(): void
			{
				const addCustomerInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) => { this.m_CustomerInputs.push( input ); this.m_Form.Input( input ); input.Base().addClass( baseclass.join( ' ' ) ); };

				this.m_CustomerData.append( ui.$$.h( 4, app.getMessage( 'Realtor.NEW.TITLE.object-person-data' ) ).addClass( 'text-muted' ) );

				let fg = ui.$$.div().addClass( 'form-group' ).appendTo( this.m_CustomerData.Root() );

				addCustomerInput(
					new ui.Form.Select(
						{
							blank: app.getMessage( 'Realtor.NEW.TITLE.SELECT.gender' ),
							option:
							{
								m: app.getMessage( 'Realtor.NEW.TITLE.GENDER.MALE.select' ),
								f: app.getMessage( 'Realtor.NEW.TITLE.GENDER.FEMALE.select' )
							},
							name: 'customer.client.gender',
							required: true
						}
					).rebuild( fg.append( ui.$$.label().text( 'Anrede' + app.getMessage( 'Aux.wildcard' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ) ),
					[ 'col-xs-12', 'col-md-4' ]
				);

				addCustomerInput(
					new ui.Form.Select(
						{
							option:
							{
								'': '',
								'Dr.': app.getMessage( 'Realtor.NEW.TITLE.SALUTATION.SELECT.dr' ),
								'Prof.': app.getMessage( 'Realtor.NEW.TITLE.SALUTATION.SELECT.prof' ),
								'Prof. Dr.': app.getMessage( 'Realtor.NEW.TITLE.SALUTATION.SELECT.profdr' )
							},
							name: 'customer.client.salutation',
						},
					).rebuild( fg.append( ui.$$.label().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.salutation' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ) ),
					[ 'col-xs-12', 'col-md-4' ]
				);

				addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.client.name',
							placeholder: app.getMessage( 'Survey.LABEL.PERSON.name' ),
							required: true,
						},
					).rebuild( ui.$$.div().addClass( 'form-group' ).append( ui.$$.label().text( app.getMessage( 'Survey.LABEL.PERSON.name' ) + app.getMessage( 'Aux.wildcard' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_CustomerData.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.client.surname',
							placeholder: app.getMessage( 'Survey.LABEL.PERSON.surname' ),
							required: true,
						},
					).rebuild( ui.$$.div().addClass( 'form-group' ).append( ui.$$.label().text( app.getMessage( 'Survey.LABEL.PERSON.surname' ) + app.getMessage( 'Aux.wildcard' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_CustomerData.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				addCustomerInput(
					new ui.Form.DateInput(
						new Date(),
						'd.m.Y',
						{
							name: 'customer.client.birthday',
							required: true,
						},
					).rebuild( ui.$$.div().addClass( 'form-group' ).append( ui.$$.label().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.birthday' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_CustomerData.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				this.m_CustomerData.append( ui.$$.h( 4, app.getMessage( 'Address.SPECIAL.PostalAddress_Administrative' ) ).addClass( 'text-muted' ) );

				fg = ui.$$.div().addClass( 'form-group' ).append(
					ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.Str_HNo' ) + app.getMessage( 'Aux.wildcard' ) ).addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_CustomerData.Root() );

				addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.address.street',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.LONG.Street' ),
						},
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-7' ]
				);

				addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.address.housenumber',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.LONG.Housenumber' ),
						},
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-3' ],
				);

				fg = ui.$$.div().addClass( 'form-group' ).append(
					ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.PC_City' ) + app.getMessage( 'Aux.wildcard' ) ).addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_CustomerData.Root() );

				addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.address.postalcode',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.SHORT.Postalcode' ),
						},
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-3' ]
				);

				addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.address.city',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.LONG.City' ),
						},
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-7' ],
				);

				fg = ui.$$.div().addClass( 'form-group' ).append(
					ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.State_Country' ) ).addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_CustomerData.Root() );

				addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.address.state',
							required: false,
							placeholder: app.getMessage( 'Address.LABEL.LONG.State' ),
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-5' ],
				);

				addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.address.country',
							required: false,
							placeholder: app.getMessage( 'Address.LABEL.LONG.Country' ),
						},
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-5' ],
				);

				this.m_CustomerData.append( ui.$$.h( 4, 'Kontaktdaten' ).addClass( 'text-muted' ) );

				fg = ui.$$.div().addClass( 'form-group' ).append(
					ui.$$.label().text( app.getMessage( 'Survey.LABEL.PERSON.PHONE.title' ) + ' 1' ).addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_CustomerData.Root() );

				addCustomerInput(
					new ui.Form.TelInput(
						'',
						{
							name: 'customer.contact.phone1.number',
							required: false,
							placeholder: app.getMessage( 'Survey.LABEL.PERSON.PHONE.number' ),
						},
					).rebuild( fg ),
					[ 'col-xs-12 col-md-10' ]
				);

				addCustomerInput(
					new ui.Form.Select(
						{
							name: 'customer.contact.phone1.type',
							required: false,
							blank: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.selection' ),
							option:
							{
								home: app.getMessage( 'Survey.LABEL.PERSON.PHONE.home' ),
								mobile: app.getMessage( 'Survey.LABEL.PERSON.PHONE.mobile' ),
								office: app.getMessage( 'Survey.LABEL.PERSON.PHONE.office' ),
							},
						},
					).rebuild( fg ),
					[ 'col-xs-12 col-md-10 col-md-offset-2' ],
				);

				addCustomerInput(
					new ui.Form.Select(
						{
							name: 'customer.contact.phone1.reachability',
							required: false,
							blank: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.reachability' ),
							option:
							{
								morning: app.getMessage( 'Survey.LABEL.PERSON.PHONE.morning' ),
								evening: app.getMessage( 'Survey.LABEL.PERSON.PHONE.evening' ),
								fullday: app.getMessage( 'Survey.LABEL.PERSON.PHONE.fullday' ),
							},
						},
					).rebuild( fg ),
					[ 'col-xs-12 col-md-10 col-md-offset-2' ]
				);

				fg = ui.$$.div().addClass( 'form-group' ).append(
					ui.$$.label().text( app.getMessage( 'Survey.LABEL.PERSON.PHONE.title' ) + ' 2' ).addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_CustomerData.Root() );

				addCustomerInput(
					new ui.Form.TelInput(
						'',
						{
							name: 'customer.contact.phone2.number',
							required: false,
							placeholder: app.getMessage( 'Survey.LABEL.PERSON.PHONE.number' ),
						},
					).rebuild( fg ),
					[ 'col-xs-12 col-md-10' ],
				);

				addCustomerInput(
					new ui.Form.Select(
						{
							name: 'customer.contact.phone2.type',
							required: false,
							blank: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.selection' ),
							option:
							{
								home: app.getMessage( 'Survey.LABEL.PERSON.PHONE.home' ),
								mobile: app.getMessage( 'Survey.LABEL.PERSON.PHONE.mobile' ),
								office: app.getMessage( 'Survey.LABEL.PERSON.PHONE.office' ),
							},
						},
					).rebuild( fg ),
					[ 'col-xs-12 col-md-10 col-md-offset-2' ],
				);

				addCustomerInput(
					new ui.Form.Select(
						{
							name: 'customer.contact.phone2.reachability',
							required: false,
							blank: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.reachability' ),
							option:
							{
								morning: app.getMessage( 'Survey.LABEL.PERSON.PHONE.morning' ),
								evening: app.getMessage( 'Survey.LABEL.PERSON.PHONE.evening' ),
								fullday: app.getMessage( 'Survey.LABEL.PERSON.PHONE.fullday' ),
							},
						},
					).rebuild( fg ),
					[ 'col-xs-12 col-md-10 col-md-offset-2' ],
				);

				fg = ui.$$.div().addClass( 'form-group' ).append( ui.$$.label().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.email_title' ) + app.getMessage( 'Aux.wildcard' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_CustomerData.Root() );

				addCustomerInput(
					new ui.Form.EmailInput(
						'',
						{
							name: 'customer.contact.email',
							required: true,
							placeholder: app.getMessage( 'Survey.LABEL.PERSON.email' ),
						},
					).rebuild( fg ),
					[ 'col-xs-12 col-md-10' ],
				);
			}

			private buildOldCustomerForm(): void
			{
				const inputs: {[key: string]: ui.Form.BasicInputField} = {};

				const staticForm: ui.Form.Form = new ui.Form.Form(
					{
						classes: [ 'form-horizontal' ],
						method: 'POST',
						action: 'object/new/DisposalRealtorObject',
						submit: () => {},
						static: true,
						notSwitchable: true,
					}
				).appendTo( this.m_CustomerData ) as ui.Form.Form;
				staticForm.Initialize();

				const addCustomerInput = ( input: ui.Form.BasicInputField, baseclass: string[] ): ui.Form.BasicInputField => { this.m_CustomerInputs.push( input ); staticForm.Input( input ); input.Base().addClass( baseclass.join( ' ' ) ); return input; };

				if ( typeof this.m_ReferenceObject != 'object' )
				{
					this.m_CustomerData.append( ui.$$.h( 4, app.getMessage( 'Realtor.NEW.TITLE.object-client-data-search' ) ) );

					const search: ui.Form.InputTypeahead = new ui.Form.InputTypeahead(
						{
							displayText: ( item: Wollmilch.ClientObject ): string =>
							{
								let address: string = "";

								item.Address.forEach( (adr) =>
									{
										if ( adr.KindOf === 'domicile' && adr.AddressType === 'PostalAddress' )
										{
											address = ', ' + adr.display;
										}
									}
								);

								return item.Surname + " " + item.Name + address;
							},
							afterSelect: ( item: Wollmilch.ClientObject ) =>
							{
								staticForm.reset();

								inputs[ 'customer.client.gender' ].value( item.Gender );
								inputs[ 'customer.client.salutation' ].value( item.Title );
								inputs[ 'customer.client.name' ].value( item.Name );
								inputs[ 'customer.client.surname' ].value( item.Surname );
								inputs[ 'customer.client.birthday' ].value( new Date(item.Birthday || new Date().pattern('d.m.Y') ).pattern('d.m.Y') );
								inputs[ 'customer.client.id' ].value( item.ID || 0 );

								item.Address.forEach( (adr) =>
									{
										if ( adr.KindOf === 'domicile' && adr.AddressType === 'PostalAddress' )
										{
											const addr: Wollmilch.PostalAddressObject = adr as Wollmilch.PostalAddressObject;

											inputs[ 'customer.address.street' ].value( addr.Street );
											inputs[ 'customer.address.housenumber' ].value( addr.HouseNumber );
											inputs[ 'customer.address.postalcode' ].value( addr.PostalCode );
											inputs[ 'customer.address.city' ].value( addr.City );
											inputs[ 'customer.address.state' ].value( addr.State );
											inputs[ 'customer.address.country' ].value( addr.Country );
										}
									}
								);
							}
						}
					).rebuild( ui.$$.div().addClass( 'form-group' ).appendTo( this.m_CustomerData.Root() ) ).addClass( 'col-xs-12' ) as ui.Form.InputTypeahead;
					this.m_CustomerData.append( ui.$$.p().append( app.getMessage( 'Realtor.NEW.TITLE.CUSTOMER.old-customer-help-text' ) ).addClass( 'help-block' ) );
				}

				this.m_CustomerData.append( ui.$$.h( 4, app.getMessage( 'Realtor.NEW.TITLE.object-person-data' ) ).addClass( 'text-muted' ) );

				let fg = ui.$$.div().addClass( 'form-group' ).appendTo( this.m_CustomerData.Root() );

				inputs[ 'customer.client.id' ] = new ui.Form.HiddenNumberInput( -1, 'customer.id' ).rebuild( fg );

				this.m_Form.Input( inputs[ 'customer.client.id' ] );

				inputs[ 'customer.client.gender' ] = addCustomerInput(
					new ui.Form.Select(
						{
							blank: app.getMessage( 'Realtor.NEW.TITLE.SELECT.gender' ),
							option:
							{
								m: app.getMessage( 'Realtor.NEW.TITLE.GENDER.MALE.select' ),
								f: app.getMessage( 'Realtor.NEW.TITLE.GENDER.FEMALE.select' ),
							},
							name: 'customer.client.gender',
							required: true,
						},
					).value(this.realtorData[0] ? this.realtorData[0] : '').rebuild( fg.append( ui.$$.label().text( 'Anrede' ).addClass( 'control-label col-xs-12 col-md-2' ) ) ),
					[ 'col-xs-12', 'col-md-4' ]
				);

				this.m_CustomerInputs.push( inputs[ 'customer.id' ] );
				this.m_Form.Input( inputs[ 'customer.id' ] );

				inputs[ 'customer.client.salutation' ] = addCustomerInput(
					new ui.Form.Select(
						{
							option:
							{
								'': '',
								'Dr.': app.getMessage( 'Realtor.NEW.TITLE.SALUTATION.SELECT.dr' ),
								'Prof.': app.getMessage( 'Realtor.NEW.TITLE.SALUTATION.SELECT.prof' ),
								'Prof. Dr.': app.getMessage( 'Realtor.NEW.TITLE.SALUTATION.SELECT.profdr' ),
							},
							name: 'customer.client.salutation',
						},
					).value(this.realtorData[1] ? this.realtorData[1] : '').rebuild( fg.append( ui.$$.label().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.salutation' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ) ),
					[ 'col-xs-12', 'col-md-4' ],
				);

				inputs[ 'customer.client.name' ] = addCustomerInput(
					new ui.Form.TextInput(
						this.realtorData[2] ? this.realtorData[2] : '',
						{
							name: 'customer.client.name',
							placeholder: app.getMessage( 'Survey.LABEL.PERSON.name' ),
							required: true,
						}
					).rebuild( ui.$$.div().addClass( 'form-group' ).append( ui.$$.label().text( app.getMessage( 'Survey.LABEL.PERSON.name' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_CustomerData.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				inputs[ 'customer.client.surname' ] = addCustomerInput(
					new ui.Form.TextInput(
						this.realtorData[3] ? this.realtorData[3] : '',
						{
							name: 'customer.client.surname',
							placeholder: app.getMessage( 'Survey.LABEL.PERSON.surname' ),
							required: true,
						},
					).rebuild( ui.$$.div().addClass( 'form-group' ).append( ui.$$.label().text( app.getMessage( 'Survey.LABEL.PERSON.surname' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_CustomerData.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ],
				);

				inputs[ 'customer.client.birthday' ] = addCustomerInput(
					new ui.Form.DateInput(
						new Date(),
						'd.m.Y',
						{
							name: 'customer.client.birthday',
							required: true,
						},
					).value(this.realtorData[4] ? this.realtorData[4] : '').rebuild( ui.$$.div().addClass( 'form-group' ).append( ui.$$.label().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.birthday' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_CustomerData.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ],
				);

				this.m_CustomerData.append( ui.$$.h( 4, app.getMessage( 'Address.SPECIAL.PostalAddress_Administrative' ) ).addClass( 'text-muted' ) );

				fg = ui.$$.div().addClass( 'form-group' ).append(
					ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.Str_HNo' ) ).addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_CustomerData.Root() );

				inputs[ 'customer.address.street' ] = addCustomerInput(
					new ui.Form.TextInput(
						this.realtorData[5] ? this.realtorData[5] : '',
						{
							name: 'customer.address.street',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.LONG.Street' ),
						},
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-7' ],
				);

				inputs[ 'customer.address.housenumber' ] = addCustomerInput(
					new ui.Form.TextInput(
						this.realtorData[6] ? this.realtorData[6] : '',
						{
							name: 'customer.address.housenumber',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.LONG.Housenumber' ),
						},
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-3' ],
				);

				fg = ui.$$.div().addClass( 'form-group' ).append(
					ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.PC_City' ) ).addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_CustomerData.Root() );

				inputs[ 'customer.address.postalcode' ] = addCustomerInput(
					new ui.Form.TextInput(
						this.realtorData[7] ? this.realtorData[7] : '',
						{
							name: 'customer.address.postalcode',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.SHORT.Postalcode' ),
						},
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-3' ],
				);

				inputs[ 'customer.address.city' ] = addCustomerInput(
					new ui.Form.TextInput(
						this.realtorData[8] ? this.realtorData[8] : '',
						{
							name: 'customer.address.city',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.LONG.City' ),
						},
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-7' ],
				);

				fg = ui.$$.div().addClass( 'form-group' ).append(
					ui.$$.label().text(
						app.getMessage( 'Address.LABEL.COMB.State_Country' )
					).addClass( 'control-label col-xs-12 col-md-2' ),
				).appendTo( this.m_CustomerData.Root() );

				inputs[ 'customer.address.state' ] = addCustomerInput(
					new ui.Form.TextInput(
						this.realtorData[9] ? this.realtorData[9] : '',
						{
							name: 'customer.address.state',
							required: false,
							placeholder: app.getMessage( 'Address.LABEL.LONG.State' ),
						},
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-5' ],
				);

				inputs[ 'customer.address.country' ] = addCustomerInput(
					new ui.Form.TextInput(
						this.realtorData[10] ? this.realtorData[10] : '',
						{
							name: 'customer.address.country',
							required: false,
							placeholder: app.getMessage( 'Address.LABEL.LONG.Country' ),
						},
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-5' ],
				);

				new Wollmilch.AJAX(
					{
						url: 'customer/list/' + this.m_Company.ID + '/limit/10000000/page/0',
						method: 'GET',
						on:
						{
							success: ( text: string ): void =>
							{
								const obj = Wollmilch.jsonize( text );

								if ( !obj ) { return; }

								this.m_CustomerList = new Array();

								obj.data.forEach( ( element: any ) => { this.m_CustomerList.push( element.Customer ); } );

								//@ts-ignore
								search.Source( this.m_CustomerList );
							},
						},
					},
				).send();
			}

			private buildContactPersonForm()
			{
				const addContactPersonInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) =>
				{
					this.m_ContactPersonInputs.push( input );
					this.m_Form.Input( input );

					input.Base().addClass( baseclass.join( ' ' ) );
				};

				let fg = ui.$$.div().addClass( 'form-group' ).appendTo( this.m_ContactPersonData.Root() );

				fg = ui.$$.div().addClass( 'form-group' )
					.append( ui.$$.label().text(
						app.getMessage( 'Survey.LABEL.PERSON.surname' ) ).addClass( 'control-label col-xs-12 col-md-2' )
					).appendTo( this.m_ContactPersonData.Root() );

				addContactPersonInput(this.m_SurveyInputs[15]
					.rebuild( fg ),
					[ 'col-xs-12', 'col-md-10' ],
				);

				fg = ui.$$.div().addClass( 'form-group' )
					.append(
						ui.$$.label().text( app.getMessage( 'Survey.LABEL.PERSON.name' ) ).addClass( 'control-label col-xs-12 col-md-2' )
					)
					.appendTo( this.m_ContactPersonData.Root() );

				addContactPersonInput(this.m_SurveyInputs[16]
					.rebuild( fg ),
					[ 'col-xs-12', 'col-md-10' ],
				);

				fg = ui.$$.div().addClass( 'form-group' )
					.append(
						ui.$$.label().text( app.getMessage( 'Survey.LABEL.PERSON.PHONE.title' )
					).addClass( 'control-label col-xs-12 col-md-2' ) )
					.appendTo( this.m_ContactPersonData.Root() );

				addContactPersonInput(this.m_SurveyInputs[17]
					.rebuild( fg ),
					[ 'col-xs-12 col-md-10' ]
				);

				addContactPersonInput(this.m_SurveyInputs[18]
					.rebuild( fg ),
					[ 'col-xs-12 col-md-10 col-md-offset-2' ],
				);

				addContactPersonInput(this.m_SurveyInputs[19]
					.rebuild( fg ),
					[ 'col-xs-12 col-md-10 col-md-offset-2' ],
				);

				fg = ui.$$.div().addClass( 'form-group' ).append(
					ui.$$.label().text( app.getMessage( 'Survey.LABEL.PERSON.email' ) ).addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_ContactPersonData.Root() );

				addContactPersonInput(this.m_SurveyInputs[20]
					.rebuild( fg ),
					[ 'col-xs-12 col-md-10' ]
				);

			}

			private buildTenantForm()
			{
				const addTenantInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) =>
				{
					this.m_TenantInputs.push( input );
					this.m_Form.Input( input );

					input.Base().addClass( baseclass.join( ' ' ) );
				};

				let fg = ui.$$.div().addClass( 'form-group' ).appendTo( this.m_TenantData.Root() );

				addTenantInput(this.m_SurveyInputs[21]
					.rebuild( fg ),
					[ 'col-xs-12', 'col-md-10', 'col-md-offset-3' ],
				);

				fg = ui.$$.div().addClass( 'form-group' )
					.append(
						ui.$$.label().text(
							app.getMessage( 'Survey.LABEL.PERSON.surname' )
						).addClass( 'control-label col-xs-12 col-md-2' )
					).appendTo( this.m_TenantData.Root() );

				addTenantInput(this.m_SurveyInputs[22]
					.rebuild( fg ),
					[ 'col-xs-12', 'col-md-10' ],
				);

				fg = ui.$$.div().addClass( 'form-group' )
					.append(
						ui.$$.label().text( app.getMessage( 'Survey.LABEL.PERSON.name' ) ).addClass( 'control-label col-xs-12 col-md-2' )
					)
					.appendTo( this.m_TenantData.Root() );

				addTenantInput(this.m_SurveyInputs[23]
					.rebuild( fg ),
					[ 'col-xs-12', 'col-md-10' ],
				);

				fg = ui.$$.div().addClass( 'form-group' )
					.append(
						ui.$$.label().text(
							app.getMessage( 'Survey.LABEL.PERSON.PHONE.title' )
						).addClass( 'control-label col-xs-12 col-md-2' )
					)
					.appendTo( this.m_TenantData.Root() );

				addTenantInput(this.m_SurveyInputs[24]
					.rebuild( fg ),
					[ 'col-xs-12 col-md-10' ],
				);

				fg = ui.$$.div().addClass( 'form-group' )
					.append(
						ui.$$.label().text(
							app.getMessage( 'Survey.LABEL.PERSON.email' )
						).addClass( 'control-label col-xs-12 col-md-2' )
					).appendTo( this.m_TenantData.Root() );

				addTenantInput(this.m_SurveyInputs[25]
					.rebuild( fg ),
					[ 'col-xs-12 col-md-10' ]
				);

			}

		}

	}

}
